// src/config/controls.ts — Klavye / mouse / gamepad eşleme tabloları (DESIGN §2). Yalnız veri; okuma input/ (WP6).
// Kural: Ctrl / Alt / Cmd içeren HİÇBİR kombinasyon yok (tarayıcı kısayolu çakışması); akor yok; sağ tık contextmenu engellenir.
import { Btn } from '../core/types.ts';

/** KeyboardEvent.code → Btn. Birincil ve ikincil tuşlar aynı tabloda. */
export const KEY_BUTTONS: Readonly<Record<string, Btn>> = {
  Space: Btn.Jump,                       // A
  KeyJ: Btn.Light,                       // X
  KeyK: Btn.Heavy,                       // Y
  KeyL: Btn.Grab, KeyE: Btn.Grab,        // B
  KeyQ: Btn.Block,                       // L1
  KeyC: Btn.Dodge,                       // R1 birincil (C)
  ShiftLeft: Btn.Dodge, ShiftRight: Btn.Dodge,   // R1 ikincil: Windows'ta 5× Shift Sticky Keys açar → menüde uyarı, C birincil
  KeyT: Btn.Taunt,                       // taunt (yalnız T / D-pad ↓)
  Escape: Btn.Start, KeyP: Btn.Start,    // duraklat (tam ekranda Esc tarayıcıya gidebilir → P ikincil)
};
/** Hareket tuşları: code → (x, z) dünya ekseni (kamera yaw 0: W = −Z = ekranın üstü/uzak kenar). */
export const KEY_MOVE: Readonly<Record<string, readonly [number, number]>> = {
  KeyW: [0, -1], ArrowUp: [0, -1],
  KeyS: [0, 1], ArrowDown: [0, 1],
  KeyA: [-1, 0], ArrowLeft: [-1, 0],
  KeyD: [1, 0], ArrowRight: [1, 0],
};
/** MouseEvent.button → Btn: sol = X, sağ = Y, orta / yan (3) = L1 alternatifi. Saldırı mouse'tan gelince InputFrame.fromMouse = true. */
export const MOUSE_BUTTONS: Readonly<Record<number, Btn>> = { 0: Btn.Light, 2: Btn.Heavy, 1: Btn.Block, 3: Btn.Block };
/** Debug tuşları (view; sim'e girmez). */
export const KEY_DEBUG_DRAW = 'F3';
/** Yasak değiştiriciler: bunlardan biri basılıyken oyun tuşu üretilmez (Ctrl+W, macOS Ctrl+tık = sağ tık…). */
export const FORBIDDEN_MODIFIERS: readonly ('ctrlKey' | 'altKey' | 'metaKey')[] = ['ctrlKey', 'altKey', 'metaKey'];

/** Gamepad standart eşleme: buttons[i] → Btn (DESIGN §2). */
export const PAD_BUTTONS: Readonly<Record<number, Btn>> = {
  0: Btn.Jump,    // A / Cross
  1: Btn.Grab,    // B / Circle
  2: Btn.Light,   // X / Square
  3: Btn.Heavy,   // Y / Triangle
  4: Btn.Block,   // L1
  5: Btn.Dodge,   // R1
  9: Btn.Start,   // Start
  13: Btn.Taunt,  // D-pad ↓ (d-pad'siz pad'de taunt yok; akor yok)
};
/** Sol çubuk eksenleri (axes[0] → dünya x, axes[1] → dünya z; pad y ileri = −1 = uzak kenar). */
export const PAD_AXIS_X = 0;
export const PAD_AXIS_Y = 1;
/** Ölü bölge (DESIGN §2: 0.18; büyüklük smoothstep 0.18 → 1.0 ile ölçeklenir — tuning INPUT.deadzone ile aynı sayı). */
export const PAD_DEADZONE = 0.18;

/** Btn biti → InputBuffer indeksi (0..7); Btn değerleri 2^i. */
export const btnIndex = (b: Btn): number => 31 - Math.clz32(b);
/** Kurtulma sayacı / mash için "4 yüz tuşu" maskesi (DESIGN §6). */
export const FACE_BUTTONS: number = Btn.Jump | Btn.Light | Btn.Heavy | Btn.Grab;
